(function () {
  var SECTION_SELECTOR = '.oddit-section-product-recommendations';

  function initSection(section) {
    var track = section.querySelector('.oddit-section-product-recommendations__grid');
    var thumb = section.querySelector('.oddit-section-product-recommendations__pagination-fill');
    var bar = section.querySelector('.oddit-section-product-recommendations__pagination');
    if (!track || !thumb || !bar) return;

    function updateProgress() {
      var maxScroll = track.scrollWidth - track.clientWidth;
      if (maxScroll <= 0) {
        thumb.style.left = '0px';
        return;
      }
      var ratio = track.scrollLeft / maxScroll;
      var maxLeft = bar.offsetWidth - thumb.offsetWidth;
      thumb.style.left = Math.round(ratio * maxLeft) + 'px';
    }

    track.addEventListener('scroll', updateProgress, { passive: true });
    updateProgress();

    var ro = new ResizeObserver(function () {
      updateProgress();
    });
    ro.observe(track);

    section._odditProductRecommendationsCleanup = function () {
      track.removeEventListener('scroll', updateProgress);
      ro.disconnect();
    };
  }

  function destroySection(section) {
    if (section._odditProductRecommendationsCleanup) {
      section._odditProductRecommendationsCleanup();
      section._odditProductRecommendationsCleanup = null;
    }
  }

  // recommendations.* is only populated by the Product Recommendations API,
  // so on first render the section is empty and has to fetch its own markup.
  function loadSection(section) {
    var url = section.dataset.recommendationsUrl;
    if (!url || section.querySelector('.oddit-section-product-recommendations__grid')) {
      initSection(section);
      return;
    }

    fetch(url)
      .then(function (res) {
        return res.text();
      })
      .then(function (text) {
        var fetched = new DOMParser()
          .parseFromString(text, 'text/html')
          .querySelector(SECTION_SELECTOR);
        if (!fetched || !fetched.querySelector('.oddit-section-product-recommendations__grid')) {
          section.hidden = true;
          return;
        }
        section.innerHTML = fetched.innerHTML;
        // Injected cards carry .oddit-reveal (opacity: 0 until observed) and the
        // drag-scroll hooks. shopify:section:load is what oddit-interactions.js
        // and initSection below both already listen on, so replay it.
        (section.closest('.shopify-section') || section).dispatchEvent(
          new CustomEvent('shopify:section:load', { bubbles: true })
        );
      })
      .catch(function () {
        section.hidden = true;
      });
  }

  document.querySelectorAll(SECTION_SELECTOR).forEach(loadSection);

  document.addEventListener('shopify:section:load', function (e) {
    var section = e.target.querySelector(SECTION_SELECTOR);
    if (section) loadSection(section);
  });

  document.addEventListener('shopify:section:unload', function (e) {
    var section = e.target.querySelector(SECTION_SELECTOR);
    if (section) destroySection(section);
  });
})();
